module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0058.jpg?v=1eefd2c3";